<script setup>
    import { ElCollapseItem, ElInput, ElOption, ElSelect, ElSwitch, ElIcon, ElInputNumber } from 'element-plus';
    import Info from "../utility/info.vue"
    import { useProductStore } from '../../stores/fpe'
    import { storeToRefs } from 'pinia';
    import { ArrowRightBold, ArrowUpBold, ArrowDownBold } from '@element-plus/icons-vue';

    const store = useProductStore();
    const { product, data_sets, manage_stocks, strings } = storeToRefs(store);

</script>

<template>
    <el-collapse-item :title="strings.section_title_inventory" class="fpe-section-inventory" name="inventory" :icon="ArrowRightBold">
        <div class="fpe-field-wrapper" data-field="sku">
            <label>{{ strings.label_sku }}</label>
            <ElInput v-model="product.sku" />
        </div>

        <div class="fpe-field-wrapper" data-field="global-unique-id">
            <label>{{ strings.label_global_unique_id }}</label>
            <ElInput v-model="product.global_unique_id" />
        </div>
        
        <div class="fpe-field-wrapper" v-if="product.type == 'variable'">
            <label>Settings below apply to all variations without manual stock management enabled.</label>
        </div>
        
        <div class="fpe-only-sku" v-if="!(product.type == 'grouped' || product.type == 'external')">
            <div class="fpe-field-wrapper fpe-inline-switcher fpe-manage-stocks" v-if="manage_stocks" data-field="manage-stocks">
            <label>{{ strings.label_manage_stocks }}
                <Info :tooltip_text="strings.tooltip_manage_stocks" />
            </label>
            <ElSwitch v-model="product.manage_stocks" />
        </div>

        <div class="fpe-field-wrapper" v-if="product.manage_stocks" data-field="stock-quantity">
            <label>{{ strings.label_stock_quantity }}</label>
            <ElInputNumber v-model="product.stock_quantity" controls-position="right" align="left">
                <template #increase-icon>
                    <el-icon>
                        <ArrowUpBold />
                    </el-icon>
                </template>
                <template #decrease-icon>
                    <el-icon>
                        <ArrowDownBold />
                    </el-icon>
                </template>
            </ElInputNumber>    
        </div>
        

        <div class="fpe-field-wrapper" v-if="product.manage_stocks" data-field="backorders">
            <label>{{ strings.label_allow_backorders }}</label>
            <ElSelect v-model="product.backorders">
                <ElOption
                    v-for="(value, name) in Object.entries(data_sets.backorder_options)"
                    :key="value[0]"
                    :label="value[1]"
                    :value="value[0]"
                />
            </ElSelect>
        </div>

        <div class="fpe-field-wrapper" v-if="product.manage_stocks" data-field="low-stock-amount">
            <label>{{ strings.label_low_stock_threshold }} 
                <Info :tooltip_text="data_sets.low_stock_threshold" />
            </label>
            <ElInputNumber
                v-model="product.low_stock_amount" 
                controls-position="right"
                align="left"
                min="0"
                
            ><template #increase-icon>
                    <el-icon>
                        <ArrowUpBold />
                    </el-icon>
                </template>
                <template #decrease-icon>
                    <el-icon>
                        <ArrowDownBold />
                    </el-icon>
                </template>
            </ElInputNumber>        
        </div>

        <div class="fpe-field-wrapper" data-field="stock-status" v-if="product.type != 'variable'">
            <label>{{ strings.label_stock_status }}</label>
            <ElSelect v-model="product.stock_status" :suffix-icon="ArrowDownBold">
                <ElOption
                    v-for="(value, name) in Object.entries(data_sets.stock_statuses)"
                    :key="value[0]"
                    :label="value[1]"
                    :value="value[0]"
                />
            </ElSelect>
        </div>

        <div class="fpe-field-wrapper fpe-inline-switcher" v-if="product.type == 'simple'" data-field="sold-individually">
            <label>{{ strings.label_sold_individually }}</label>
            <ElSwitch v-model="product.sold_individually" />
        </div>    
        </div>



    </el-collapse-item>
</template>